/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrChildContentModule } from "igniteui-react-core";
import { IgrInputModule } from './igr-input-module';
import { IgrLabelModule } from './igr-label-module';
import { IgrInputGroup } from './igr-input-group';
import { InputGroup } from './InputGroup';
import { TypeRegistrar } from "igniteui-react-core";
var IgrInputGroupModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrInputGroupModule() {
    }
    IgrInputGroupModule.register = function () {
        IgrChildContentModule.register();
        IgrInputModule.register();
        IgrLabelModule.register();
        TypeRegistrar.registerCons('IgrInputGroup', IgrInputGroup);
        TypeRegistrar.registerCons('IgrInputGroup', IgrInputGroup);
        TypeRegistrar.register('InputGroup', InputGroup.$type);
    };
    return IgrInputGroupModule;
}());
export { IgrInputGroupModule };
//# sourceMappingURL=igr-input-group-module.js.map
